import ApiService from "../services/api.service";
import SettingsService from "@/services/settings.service.js";
import Vue from "vue";

const state = {};

const getters = {};

const actions = {
  // eslint-disable-next-line
  async fetchUrl({ state }, url) {
    const response = await ApiService.get(url);
    Vue.$log.info(response);
    return response.data;
  },
  // eslint-disable-next-line
  fetchFile({ state }, params) {
    return ApiService.download(params.url, params.filename);
  },
  // eslint-disable-next-line
  canadaPostFind({ state }, options) {
    console.log(options);
    const settings = SettingsService.settings;
    const url = `${settings.CanadaPostURL}Find/v2.10/json3.ws`;
    let query = `?Key=${options.payload.Key}&SearchTerm=${
      options.payload.SearchTerm
    }&Country=${options.payload.Country}&LanguagePreference=${
      options.payload.LanguagePreference
    }`;
    if (options.payload.LastId) {
      query+="&LastId="+options.payload.LastId
    }
    return ApiService.getCanadaPost(url + query);
  },
  // eslint-disable-next-line
  canadaPostRetrieve({ state }, options) {
    const settings = SettingsService.settings;
    const url = `${settings.CanadaPostURL}Retrieve/v2.11/json3.ws`;
    const query = `?Key=${options.payload.Key}&Id=${options.payload.Id}`;
    return ApiService.getCanadaPost(url + query);
  },
};

const mutations = {};

export const data = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
